<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
    </ion-content>
  </ion-app>
</template>

<script>
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "DownloadPage",
  components: {
    Loading
  },
  data() {
    return {
      isLoading: true,
      fullPage: true
    };
  },
  created() {
    let OS;
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log(userAgent);
    if (userAgent.match(/Android/i)) {
      OS = "android";
    } else if (userAgent.match(/iPhone/i)) {
      OS = "ios";
    } else if (userAgent.match(/iPod/i)) {
      OS = "ios";
    } else if (userAgent.match(/iPad/i)) {
      OS = "ios";
    } else if (userAgent.match(/Mac/i)) {
      OS = "ios";
    } else {
      OS = "android";
    }
    console.log(OS);
    if (OS === "ios") {
      window.location =
        "https://apps.apple.com/us/app/updiet/id1484349177?l=pt#?platform=iphone";
    } else {
      window.location =
        "https://play.google.com/store/apps/details?id=com.updiet";
    }
  }
};
</script>

<style scoped>
</style>
